import ModelService from '@/contracts/ModelService'
import { http } from '@/plugins/http'
import DataResponse from '@/types/DataResponse'
import PaginatedResponse from '@/types/PaginatedResponse'
import PaymentMethod from '@/types/PaymentMethod'
import { AxiosResponse } from 'axios'

export default class PaymentMethodService extends ModelService<PaymentMethod> {
  index(page: number, filters: string, per_page: number | undefined): Promise<AxiosResponse<PaginatedResponse<PaymentMethod>>> {
    return http.get(`/api/v1/office/payment-methods?page=${page}&${filters}&per_page=${per_page}`)
  }

  show(_id: string): Promise<AxiosResponse<DataResponse<PaymentMethod>>> {
    throw new Error('Method not implemented.')
  }

  store(_model: PaymentMethod): Promise<AxiosResponse<DataResponse<PaymentMethod>>> {
    throw new Error('Method not implemented.')
  }

  update(_id: string, _model: PaymentMethod): Promise<AxiosResponse<DataResponse<PaymentMethod>>> {
    throw new Error('Method not implemented.')
  }

  destroy(_model: PaymentMethod): Promise<AxiosResponse> {
    throw new Error('Method not implemented.')
  }
}
